import { render, staticRenderFns } from "./HotelAllUoko.vue?vue&type=template&id=ed5f53a4&scoped=true"
import script from "./HotelAllUoko.vue?vue&type=script&lang=js"
export * from "./HotelAllUoko.vue?vue&type=script&lang=js"
import style0 from "./HotelAllUoko.vue?vue&type=style&index=0&id=ed5f53a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5f53a4",
  null
  
)

export default component.exports